import { atom } from 'recoil';

export const setFetchTreatment = atom({
    key: 'setFetchTreatment', // unique ID (with respect to other atoms/selectors)
    default: [] // default value (aka initial value)
});  